<template>
    <div class="user_jf_pop no-trans" v-loading="loading">
        <el-dialog title="邀请赚积分" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose">
            <div class="dialog_box">
              <div class="lefts">
                <div class="titles">我的邀请码</div>
                <div class="title_coed">{{ yqm }}</div>
                <div class="code_btns" @click="handle_clipboard(yqm)">复制邀请码</div>
                <!-- <div class="erm_text1">邀请二维码</div>
                <div class="erm_imgs">
                    
                </div>
                <div class="erm_text2">扫一扫</div> -->
              </div>
              <div class="lefts">
                <div class="titles">邀请链接</div>
                <div class="title_coed">{{ yqm_url }}</div>
                <div class="code_btns" @click="handle_clipboard(yqm_url)">复制邀请码</div>
                <!-- <div class="erm_text1">分享海报</div>
                <div class="erm_imgs">
                    
                </div>
                <div class="erm_text2">下载</div> -->
              </div>
                
            </div>
        </el-dialog>

       
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
export default {
    components: {
    },
    name: "homes",
    data() {
        return {
            loading:false,
            dialogVisible:false,//显示隐藏
            yqm:'',
            yqm_url:'',
            
           
        }
    },
    computed: {
       
    },
    watch: {

    },
    created() {
        this.get_UserInfo()
    },
    methods: {
        handleClose(){
            this.dialogVisible=false
        },
       
        handle_open(){
            this.dialogVisible=true
        },
        handle_clipboard(text){
            navigator.clipboard.writeText(text).then(function() {
                alertSucc("复制成功！");
            }).catch(function(err) {
                alertErr("复制失败：" + err);
            });
        },
        get_UserInfo(){
            this.loading=true
            this.$api("getUserInfo", {
                
			}, "get").then((res) => {
                this.loading = false
                console.log('我的奖励',res)
                if (res.code == 1) {
                    this.money=res.data.money
                    this.yqm=res.data.yqm
                    let url=window.location.host
                    console.log('url',url)
                    this.yqm_url=url+'/enroll?code='+res.data.yqm
                } else {
                    alertErr(res.msg)
                }
            });
        },



    },

}
</script>
<style scoped lang="less">
.user_jf_pop {
    /deep/.el-dialog__wrapper{
        .el-dialog{
            width: 791px;
            .el-dialog__header{
                background: #F7F7F7;
            }
            .el-dialog__body{
                .dialog_box{
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    .lefts{
                        .titles{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            margin-bottom: 43px;
                        }
                        .title_coed{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            margin-bottom: 10px;
                        }
                        .code_btns{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;
                            cursor: pointer;
                            margin-bottom: 40px;
                        }
                        .erm_text1{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            margin-bottom: 23px;
                        }
                        .erm_imgs{
                            width: 87px;
                            height: 87px;
                            background: #666666;
                            border-radius: 0px 0px 0px 0px;
                        }
                        .erm_text2{
                            width: 87px;
                            text-align: center;
                            margin-top: 11px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;
                            cursor: pointer;
                        }
                    }
                }
               
            }
        }
    }
}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .user_jf_pop.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .user_jf_pop.no-trans /deep/ .el-dialog__wrapper .el-dialog {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .user_jf_pop.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_jf_pop.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .lefts .titles {
        font-size: 14px;
        margin-bottom: 16px;
    }
    .user_jf_pop.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .lefts .title_coed {
        font-size: 14px;
        margin-bottom: 10px;
    }
    .user_jf_pop.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .lefts .code_btns {
        font-size: 14px;
        margin-bottom: 16px;
    }
    .user_jf_pop.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .lefts .erm_text1 {
        font-size: 14px;
        margin-bottom: 16px;
    }
    .user_jf_pop.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .lefts .erm_imgs {
        width: 87px;
        min-height: 0;
        height: auto;
        border-radius: 0px 0px 0px 0px;
    }
    .user_jf_pop.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .lefts .erm_text2 {
        width: 87px;
        margin-top: 11px;
        font-size: 14px;
    }
}
</style>
